<div class="container mx-auto device-content">
    <div class="hero-text" fxLayout="row" fxFlexAlign="center">
        <h1 style="font-weight:800;">{{'POLYGON_ADDING_FORM'|translate}}</h1>
    </div>
    <form #form="ngForm">
        <div fxLayout="row wrap" fxFlexAlign="center">
            <div fxFlex="100">
                <mat-form-field appearance="outline" floatLabel="always" class="w-100-p">
                    <mat-label>{{'TITLE'|translate}}</mat-label>
                    <input matInput placeholder="{{'TITLE'|translate}}" name="title" [(ngModel)]="model.name" required>
                </mat-form-field>
                <mat-form-field *ngIf="companyId==1" appearance="outline" floatLabel="always" class="w-100-p">
                    <mat-label>{{'COMPANY'|translate}}</mat-label>
                    <mat-select [(ngModel)]="selectedCompany" placeholder="{{'COMPANY'|translate}}" required
                        name="companies">
                        <mat-option *ngFor="let item of companyList" name="copaniesOptions" [value]="item.id">
                            {{item.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" floatLabel="always" class="w-100-p">
                    <mat-label>{{'CONTAINER_COLLECTION_THRESHOLD'|translate}}</mat-label>
                    <input matInput placeholder="{{'CONTAINER_COLLECTION_THRESHOLD'|translate}}" name="threshold" type="number" max="100"
                        min="0" [(ngModel)]="model.treshold" required>
                </mat-form-field>
                <mat-form-field appearance="outline" floatLabel="always" class="w-100-p">
                    <mat-label>{{'POINTS'|translate}}</mat-label>
                    <input matInput placeholder="{{'POINTS'|translate}}" name="points" [(ngModel)]="model.points" required>
                </mat-form-field>
            </div>
            <button style="margin-top: 10px;" mat-raised-button (click)="save()">
                <span>{{'CREATE'|translate}}</span>
            </button>
        </div>
    </form>
</div>